module.exports = __webpack_public_path__ + "img/logo_sig.7cd3a8df.svg";